import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-radio_checked",
  "use": "icon-radio_checked-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-radio_checked\"><path d=\"M10 1.667a8.333 8.333 0 1 1 0 16.666 8.333 8.333 0 0 1 0-16.666Zm3.814 5.632a.625.625 0 0 0-.884 0l-3.978 3.976-1.62-1.62a.625.625 0 1 0-.884.884l2.062 2.063a.622.622 0 0 0 .389.18h.106l.106-.017a.622.622 0 0 0 .283-.163l4.42-4.42a.625.625 0 0 0 0-.883Z\" fill=\"#5CC728\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol